import { WithClassName } from 'src/utils/UtilityTypes';
import { cj } from 'src/utils/classNames';

interface Props extends WithClassName {
	/**
	 * Note this should be zero-indexed.
	 */
	currentStep: number;
	totalSteps: number;
	onClick?: (step: number) => void;
}

export default function StepIndicator({
	currentStep,
	totalSteps,
	className,
	onClick,
}: Props) {
	return (
		<div className={cj('flex items-center gap-x-sm', className)}>
			{Array.from({ length: totalSteps }, (_, stepNumber) => {
				const isActive = stepNumber === currentStep;

				return (
					<button
						key={stepNumber}
						onClick={() => onClick?.(stepNumber)}
						className={cj('-m-xs p-xs', !onClick && 'cursor-default')}
					>
						{/* We use an extra inner el here so that we can apply padding & margin */}
						{/* separately to the button to increase the hit area. */}
						<div
							className={cj(
								'h-xs w-md',
								isActive ? 'bg-button-primary-bg' : 'bg-text-disabled'
							)}
						/>
					</button>
				);
			})}
		</div>
	);
}
